import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Box,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";

const ApprovePickupWithoutSignatureDialog = ({
  open,
  handleClose,
  onConfirm,
  errorMessage,
  loading,
}) => {
  const theme = useTheme();
  const [confirmText, setConfirmText] = useState(null);

  return (
    <Dialog
      keepMounted
      scroll={"paper"}
      maxWidth="sm"
      fullWidth={true}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Customer Not Available for Signature</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Please confirm that you want to skip customer approval for this
          delivery
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="Type 'confirm'"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
        <Box>
          {errorMessage && (
            <Box>
              <Typography color={"red"}>{errorMessage}</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={() => {
            setConfirmText("");
            handleClose();
          }}
          loading={loading}
        >
          Back
        </LoadingButton>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={confirmText != "confirm"}
          onClick={onConfirm}
        >
          Complete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default ApprovePickupWithoutSignatureDialog;
